import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTreasure: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="treasure, chest"><path d="M3 10.75H21" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 4.75V19.25" stroke="currentColor" strokeWidth="1.5"/><path d="M16.25 4.75V19.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 9.75V11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 7.75C2.75 6.09315 4.09315 4.75 5.75 4.75H18.25C19.9069 4.75 21.25 6.09315 21.25 7.75V19.25H2.75V7.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconTreasure;
